import React from 'react';
import PropTypes from 'prop-types';

const CustomFilledButton = ({ label, onClick, disabled }) => {
  return (
    <button
      className={`flex flex-row justify-center items-center px-6 py-4 gap-[10px] w-[222px] font-bold text-[20px] h-[57px] bg-[#148536] text-white rounded-[8px] ${
        disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-green-700'
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

CustomFilledButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

CustomFilledButton.defaultProps = {
  onClick: () => {},
  disabled: false,
};

export default CustomFilledButton;